// src/components/CustomButton.js

import classes from "./CustomButton.module.css";
import { Loader } from "lucide-react";
import { resolveIcon } from "../utils/resolveIcon";
import { width } from "@mui/system";

export default function CustomButton({
  elementType,
  title,
  content,
  icon,                 // can be "check" OR imported icon src
  iconSize = 18,
  variant,
  minWidth,
  noMaxWidth,
  reverseIcon,
  disabled,
  classList,
  mobileEffect = false,
  loading = false,
  ...props
}) {
  const Element = elementType ? elementType : "button";
  const iconSrc = resolveIcon(icon);

  return (
    <Element
      className={`${classes.customButton} ${variant ? classes[variant] : ""} ${
        disabled ? classes.disabled : ""
      } ${classList ? classList : ""}`}
      style={{
        minWidth: minWidth || "",
        pointerEvents: disabled ? "none" : "",
        opacity: disabled ? 0.5 : 1,
        maxWidth: noMaxWidth? "100%" : "250px",
        width: noMaxWidth? "100%" : "unset"
      }}
      disabled={Element === "button" ? disabled : undefined}
      {...props}
    >
      {loading && (
        <Loader
          size={iconSize}
          style={{ animation: "spin 1s linear infinite" }}
        />
      )}

      {!loading && !reverseIcon && iconSrc && (
        <img
          src={iconSrc}
          alt={title}
          style={{ width: iconSize + "px" }}
          className={classes.icon}
        />
      )}

      {title && (
        <span
          className={`${classes.title} ${
            mobileEffect ? "hidden u-show-at-mq-200" : ""
          }`}
        >
          {title}
        </span>
      )}

      {content && content}

      {!loading && reverseIcon && iconSrc && (
        <img
          src={iconSrc}
          alt={title}
          style={{ width: iconSize + "px" }}
          className={classes.icon}
        />
      )}
    </Element>
  );
}
